export enum DOTFormType {
  DOT_NUMBER = 'dotNumber',
  USDOT_NUMBER = 'usDotNumber',
  NO_NUMBER = 'noNumber',
}
